import $ from 'jquery';

const ITEM_TARGET_CLASS = 'pillar-list__item';
const ITEM_ACTIVE_CLASS = ITEM_TARGET_CLASS + '--complete';
const ITEM_LOADING_CLASS = ITEM_TARGET_CLASS + '--loading';

$(() => {
    const $pillarList = $('.pillar-list');

    if ($pillarList.length) {
        $pillarList.on('click', `.${ITEM_TARGET_CLASS}__completion`, function() {
            let $item = $(this).parents(`.${ITEM_TARGET_CLASS}`);
            let itemIsComplete: boolean = !$item.hasClass(ITEM_ACTIVE_CLASS);

            $item.addClass(ITEM_LOADING_CLASS);

            let request = $.ajax({
                type: 'GET',
                url: (<any> window).Buckle.urls.ajax,
                data: {
                    'action': 'complete_pillar_toggle',
                    'pillar_id' : <number> $item.data('pillar-id'),
                    'complete' : itemIsComplete,
                    '_nonce' : (<any> window).Buckle.vars._nonce,
                }
            });

            request.done(response => {
                console.log(response);

                $item.toggleClass(ITEM_ACTIVE_CLASS).removeClass(ITEM_LOADING_CLASS);
            });

            request.fail((xhr, error) => {
                alert('There was an error updating the completion status of the selected module. Please notify a site administrator.');

                if ((<any> window).Buckle.vars.debug) {
                    console.error(error);
                }
            });
        });
    }
});



// WEBPACK FOOTER //
// ./resources/assets/scripts/components/CompletePillarToggle.ts